exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bgColor {\n  box-shadow: inset 0 0 0 1000px rgba(0, 0, 0, 0.75); }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/alinu/Alin/Work/Workspace/BART-client/src/app/routes/user/login/login.component.scss
// module id = ../../../../../src/app/routes/user/login/login.component.scss
// module chunks = main